'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useState } from 'react';
import { Button } from '@edusense/shared-ui-kit';
import { pollWidget_optionPlaceholder, pollWidget_deleteOption, pollWidget_addOption, pollWidget_pollDuration, pollWidget_duration1Day, pollWidget_duration3Days, pollWidget_duration7Days } from '@paraglide/messages';
/**
 * 투표 옵션 컴포넌트
 * 투표 옵션 관리와 표시를 담당
 */ export default function PollOptions(param) {
    var poll = param.poll, setPoll = param.setPoll, _param_isSubmitting = param.isSubmitting, isSubmitting = _param_isSubmitting === void 0 ? false : _param_isSubmitting;
    var _useState = _sliced_to_array(useState('1d'), 2), selectedDuration = _useState[0], setSelectedDuration = _useState[1];
    // 투표 옵션 텍스트 변경 핸들러
    var handleOptionChange = function(index, text) {
        if (!poll) return;
        var updatedOptions = _to_consumable_array(poll.options);
        updatedOptions[index] = _object_spread_props(_object_spread({}, updatedOptions[index]), {
            text: text
        });
        setPoll(_object_spread_props(_object_spread({}, poll), {
            options: updatedOptions
        }));
    };
    // 투표 옵션 추가 핸들러
    var handleAddOption = function() {
        if (!poll) return;
        // 최대 4개 옵션까지만 허용
        if (poll.options.length >= 4) return;
        setPoll(_object_spread_props(_object_spread({}, poll), {
            options: _to_consumable_array(poll.options).concat([
                {
                    text: '',
                    votes: 0
                }
            ])
        }));
    };
    // 투표 옵션 삭제 핸들러
    var handleRemoveOption = function(index) {
        if (!poll) return;
        // 최소 2개 옵션은 유지
        if (poll.options.length <= 2) return;
        var updatedOptions = _to_consumable_array(poll.options);
        updatedOptions.splice(index, 1);
        setPoll(_object_spread_props(_object_spread({}, poll), {
            options: updatedOptions
        }));
    };
    // 투표 기간 변경 핸들러
    var handleDurationChange = function(duration) {
        if (!poll) return;
        setSelectedDuration(duration);
        // 현재 시간 기준으로 종료 시간 계산
        var now = new Date();
        var endTime;
        switch(duration){
            case '1d':
                endTime = new Date(now.getTime() + 24 * 60 * 60 * 1000);
                break;
            case '3d':
                endTime = new Date(now.getTime() + 3 * 24 * 60 * 60 * 1000);
                break;
            case '7d':
                endTime = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);
                break;
            default:
                endTime = new Date(now.getTime() + 24 * 60 * 60 * 1000);
        }
        setPoll(_object_spread_props(_object_spread({}, poll), {
            endTime: endTime
        }));
    };
    if (!poll) return null;
    return /*#__PURE__*/ React.createElement("div", {
        className: "mt-2 mb-3 border border-gray-200 dark:border-gray-700 rounded-lg p-3"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "space-y-2"
    }, poll.options.map(function(option, index) {
        return /*#__PURE__*/ React.createElement("div", {
            key: index,
            className: "flex items-center"
        }, /*#__PURE__*/ React.createElement("input", {
            type: "text",
            className: "flex-1 p-2 border border-gray-200 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100",
            placeholder: pollWidget_optionPlaceholder({
                number: (index + 1).toString()
            }),
            value: option.text,
            onChange: function(e) {
                return handleOptionChange(index, e.target.value);
            },
            disabled: isSubmitting,
            maxLength: 25
        }), poll.options.length > 2 && /*#__PURE__*/ React.createElement("button", {
            type: "button",
            className: "ml-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200",
            onClick: function() {
                return handleRemoveOption(index);
            },
            disabled: isSubmitting,
            "aria-label": pollWidget_deleteOption()
        }, "\xd7"));
    })), poll.options.length < 4 && /*#__PURE__*/ React.createElement(Button, {
        variant: "ghost",
        size: "sm",
        className: "mt-2 text-blue-500 dark:text-blue-400",
        onClick: handleAddOption,
        disabled: isSubmitting
    }, pollWidget_addOption()), /*#__PURE__*/ React.createElement("div", {
        className: "mt-3 flex items-center text-sm text-gray-500 dark:text-gray-400"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "mr-2"
    }, pollWidget_pollDuration()), /*#__PURE__*/ React.createElement("div", {
        className: "flex space-x-2"
    }, /*#__PURE__*/ React.createElement("button", {
        type: "button",
        className: "px-2 py-1 rounded-full ".concat(selectedDuration === '1d' ? 'bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400' : 'bg-gray-100 dark:bg-gray-800'),
        onClick: function() {
            return handleDurationChange('1d');
        },
        disabled: isSubmitting
    }, pollWidget_duration1Day()), /*#__PURE__*/ React.createElement("button", {
        type: "button",
        className: "px-2 py-1 rounded-full ".concat(selectedDuration === '3d' ? 'bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400' : 'bg-gray-100 dark:bg-gray-800'),
        onClick: function() {
            return handleDurationChange('3d');
        },
        disabled: isSubmitting
    }, pollWidget_duration3Days()), /*#__PURE__*/ React.createElement("button", {
        type: "button",
        className: "px-2 py-1 rounded-full ".concat(selectedDuration === '7d' ? 'bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400' : 'bg-gray-100 dark:bg-gray-800'),
        onClick: function() {
            return handleDurationChange('7d');
        },
        disabled: isSubmitting
    }, pollWidget_duration7Days()))));
}
